import React, { useState } from "react";
import { getBackendUrl } from "../config";

export default function ForgotPasswordModal({ onClose }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null); // { type: 'success' | 'google_only' | 'error', message, devLink }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);

    try {
      const res = await fetch(`${getBackendUrl()}/api/auth/password-reset/request`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
      const data = await res.json();
      setLoading(false);

      if (data.status === "google_only") {
        setResult({
          type: "google_only",
          message: data.message,
        });
      } else if (res.ok && data.status === "success") {
        setResult({
          type: "success",
          message: data.message,
          devLink: data.reset_link_dev,
        });
      } else {
        setResult({
          type: "error",
          message: data.message || "Impossible de traiter la demande.",
        });
      }
    } catch (err) {
      setLoading(false);
      setResult({
        type: "error",
        message: "Erreur réseau. Veuillez réessayer.",
      });
    }
  };

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0, 0, 0, 0.85)", backdropFilter: "blur(8px)",
      zIndex: 9999, display: "flex", justifyContent: "center", alignItems: "center",
      padding: "20px"
    }}>
      <div style={{
        background: "#12131C", border: "1px solid #2A2D3E", borderRadius: "16px",
        maxWidth: "440px", width: "100%", padding: "30px", boxShadow: "0 20px 50px rgba(0,0,0,0.8)",
        color: "#fff", fontFamily: "Inter, system-ui, sans-serif"
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
          <h3 style={{ margin: 0, fontSize: "1.25rem", color: "#00f0ff" }}>🔑 Récupération d'Accès</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#888", fontSize: "1.5rem", cursor: "pointer" }}>×</button>
        </div>

        {!result ? (
          <form onSubmit={handleSubmit}>
            <p style={{ color: "#aaa", fontSize: "0.9rem", marginBottom: "20px", lineHeight: "1.4" }}>
              Saisissez l'adresse email associée à votre identité centrale. Un lien de réinitialisation valide <strong>20 minutes</strong> vous sera transmis.
            </p>
            <div style={{ marginBottom: "20px" }}>
              <label style={{ display: "block", fontSize: "0.85rem", color: "#ccc", marginBottom: "8px" }}>Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre.email@domaine.com"
                style={{
                  width: "100%", padding: "12px", background: "#1A1C29", border: "1px solid #33374A",
                  borderRadius: "8px", color: "#fff", fontSize: "0.95rem", boxSizing: "border-box"
                }}
              />
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <button
                type="button"
                onClick={onClose}
                style={{
                  flex: 1, padding: "12px", background: "transparent", border: "1px solid #444",
                  borderRadius: "8px", color: "#ccc", cursor: "pointer"
                }}
              >
                Annuler
              </button>
              <button
                type="submit"
                disabled={loading}
                style={{
                  flex: 1, padding: "12px", background: "linear-gradient(135deg, #00f0ff, #7000ff)",
                  border: "none", borderRadius: "8px", color: "#fff", fontWeight: "bold", cursor: "pointer",
                  opacity: loading ? 0.6 : 1
                }}
              >
                {loading ? "Envoi..." : "Envoyer le lien"}
              </button>
            </div>
          </form>
        ) : (
          <div>
            {result.type === "google_only" && (
              <div style={{ background: "rgba(255, 170, 0, 0.15)", border: "1px solid #ffaa00", borderRadius: "8px", padding: "15px", marginBottom: "20px" }}>
                <div style={{ color: "#ffaa00", fontWeight: "bold", marginBottom: "6px" }}>ℹ️ Compte géré par Google</div>
                <p style={{ margin: 0, fontSize: "0.9rem", color: "#ddd", lineHeight: "1.4" }}>{result.message}</p>
              </div>
            )}

            {result.type === "success" && (
              <div style={{ background: "rgba(0, 255, 148, 0.15)", border: "1px solid #00ff94", borderRadius: "8px", padding: "15px", marginBottom: "20px" }}>
                <div style={{ color: "#00ff94", fontWeight: "bold", marginBottom: "6px" }}>✅ Demande prise en compte</div>
                <p style={{ margin: 0, fontSize: "0.9rem", color: "#ddd", lineHeight: "1.4" }}>{result.message}</p>
                {result.devLink && (
                  <div style={{ marginTop: "12px", paddingTop: "12px", borderTop: "1px border rgba(255,255,255,0.1)", fontSize: "0.8rem", color: "#888" }}>
                    <span style={{ color: "#00f0ff" }}>[Lien de test local] :</span>{" "}
                    <a href={result.devLink} style={{ color: "#00f0ff", wordBreak: "break-all" }}>{result.devLink}</a>
                  </div>
                )}
              </div>
            )}

            {result.type === "error" && (
              <div style={{ background: "rgba(255, 50, 50, 0.15)", border: "1px solid #ff3232", borderRadius: "8px", padding: "15px", marginBottom: "20px" }}>
                <div style={{ color: "#ff3232", fontWeight: "bold", marginBottom: "6px" }}>⚠️ Erreur</div>
                <p style={{ margin: 0, fontSize: "0.9rem", color: "#ddd" }}>{result.message}</p>
              </div>
            )}

            <button
              onClick={onClose}
              style={{
                width: "100%", padding: "12px", background: "#2A2D3E", border: "none",
                borderRadius: "8px", color: "#fff", fontWeight: "bold", cursor: "pointer"
              }}
            >
              Fermer
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
